import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Check, X, Star, Briefcase, Zap } from "lucide-react";
import { useAuth } from "../../context/AuthContext";


const PricingPage = () => {
    const auth = useAuth();

    const plans = [
        {
            name: "Basic",
            price: "0€",
            period: "dauerhaft kostenlos",
            description: "Perfekt für den Einstieg.",
            icon: <Zap size={24} className="text-primary" />,
            features: [
                { name: "Checklisten", included: true },
                { name: "Einkaufslisten", included: true },
                { name: "Essensplanung", included: true },
                { name: "Notizen", included: true },
                { name: "1 Workspace", included: true },
                { name: "Aufgaben (Tasks)", included: false },
                { name: "Seiten (Pages)", included: false },
                { name: "Werbefrei", included: false },
            ],
            buttonText: "Kostenlos starten",
            buttonVariant: "btn-outline-primary",
            highlight: false,
        },
        {
            name: "Pro",
            price: "4.99€",
            period: "pro Monat / jährlich",
            description: "Für Familien, die mehr wollen.",
            icon: <Star size={24} className="text-warning" />,
            features: [
                { name: "Checklisten", included: true },
                { name: "Einkaufslisten", included: true },
                { name: "Essensplanung", included: true },
                { name: "Notizen", included: true },
                { name: "Bis zu 5 Workspaces", included: true },
                { name: "Aufgaben (Tasks)", included: true },
                { name: "Seiten (Pages)", included: true },
                { name: "Werbefrei", included: true },
                { name: "Meal Plan Agent", included: true },
                { name: "ShoppingList Autofill", included: true },
                { name: "Calendar Sync (CalDAV)", included: true },
            ],
            buttonText: "Pro testen",
            buttonVariant: "btn-primary",
            highlight: true,
            discount: "30% Rabatt im 1. Jahr",
        },
        {
            name: "Business",
            price: "Individuell",
            period: "pro Nutzer",
            description: "Für Teams und Organisationen.",
            icon: <Briefcase size={24} className="text-success" />,
            features: [
                { name: "Alles aus Pro", included: true },
                { name: "Unbegrenzte Workspaces", included: true },
                { name: "Admin Dashboard", included: true },
                { name: "Priority Support", included: true },
                { name: "SSO Integration", included: true },
            ],
            buttonText: "Kontaktieren",
            buttonVariant: "btn-outline-dark",
            highlight: false,
        },
    ];

    return (
        <div className="d-flex flex-column min-vh-100">


            <main className="flex-grow-1 bg-light py-5">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h1 className="fw-bold display-4 mb-3">Wähle deinen Plan</h1>
                        <p className="text-secondary fs-5" style={{ maxWidth: "600px", margin: "0 auto" }}>
                            Egal ob Single, Familie oder Business – wir haben das passende Paket für dich.
                        </p>
                    </div>

                    <div className="row g-4 justify-content-center align-items-center">
                        {plans.map((plan, index) => (
                            <div key={index} className="col-lg-4 col-md-6">
                                <div
                                    className={`card h-100 border-0 shadow-sm transition-all ${plan.highlight ? 'border-primary ring-2' : ''}`}
                                    style={{
                                        borderRadius: "20px",
                                        transform: plan.highlight ? "scale(1.05)" : "scale(1)",
                                        zIndex: plan.highlight ? 10 : 1,
                                        boxShadow: plan.highlight ? "0 20px 40px -10px rgba(13, 110, 253, 0.15)" : ""
                                    }}
                                >
                                    {plan.highlight && plan.discount && (
                                        <div className="position-absolute top-0 start-50 translate-middle badge bg-danger rounded-pill px-3 py-2 shadow-sm">
                                            {plan.discount}
                                        </div>
                                    )}

                                    <div className="card-body p-4 p-lg-5 d-flex flex-column">
                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <div className={`p-3 rounded-4 bg-opacity-10 ${plan.highlight ? 'bg-primary' : 'bg-light'}`}>
                                                {plan.icon}
                                            </div>
                                            <div>
                                                <h4 className="fw-bold mb-0">{plan.name}</h4>
                                                <small className="text-secondary">{plan.description}</small>
                                            </div>
                                        </div>

                                        <div className="mb-4">
                                            <h2 className="fw-bold display-5 mb-0">{plan.price}</h2>
                                            <span className="text-secondary small">{plan.period}</span>
                                        </div>

                                        <ul className="list-unstyled mb-5 flex-grow-1">
                                            {plan.features.map((feature, fIndex) => (
                                                <li key={fIndex} className="d-flex align-items-center gap-2 mb-3">
                                                    {feature.included ? (
                                                        <Check size={18} className="text-success flex-shrink-0" />
                                                    ) : (
                                                        <X size={18} className="text-muted opacity-25 flex-shrink-0" />
                                                    )}
                                                    <span className={feature.included ? "" : "text-muted opacity-50"}>
                                                        {feature.name}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>

                                        <button
                                            className={`btn btn-lg w-100 rounded-pill fw-bold ${plan.buttonVariant}`}
                                            onClick={() => auth.login()}
                                        >
                                            {plan.buttonText}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>



            <style>{`
        .transition-all {
            transition: all 0.3s ease;
        }
        .ring-2 {
            border: 2px solid #0d6efd !important;
        }
      `}</style>
        </div>
    );
};

export default PricingPage;
